function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6157 70.74C33.9868 70.74 44.5423 78.7022 51.949 78.7022C59.3557 78.7022 74.9112 74.4444 74.9112 40.3711C74.9112 6.29775 53.9845 1.29553 45.8379 1.29553C7.68899 1.29553 -8.60657 70.74 18.6157 70.74Z",
  fill: "#F7F7F9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M61.3891 11.6666H63.6113V16.1111H61.3891V11.6666Z",
  fill: "#A4AFC1"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M66.3891 18.3334H70.8335V20.5556H66.3891V18.3334Z",
  fill: "#A4AFC1"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M45.0001 58.3333H18.889C16.4334 58.3333 14.4445 56.3444 14.4445 53.8889V19.4444C14.4445 16.9889 16.4334 15 18.889 15H45.0001C47.4556 15 49.4445 16.9889 49.4445 19.4444V53.8889C49.4445 56.3444 47.4556 58.3333 45.0001 58.3333Z",
  fill: "#F7F7F9"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M47.8489 63.8222L41.1711 65L42.3489 58.3222L58.8489 41.8222C59.7178 40.9533 60.7311 40.5622 61.5978 41.4289L64.3467 44.1778C65.2156 45.0466 65.2156 46.4533 64.3467 47.32L47.8489 63.8222Z",
  fill: "#E7F5FE"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M47.3512 58.3222L62.9223 42.7511L61.6001 41.4289C60.7312 40.56 59.7178 40.9533 58.8512 41.8222L42.3512 58.3222L41.1734 65L46.3334 64.0889L47.3512 58.3222Z",
  fill: "#B6E2FB"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M19.4445 53.8889V19.4444C19.4445 16.9889 21.4334 15 23.889 15H18.889C16.4334 15 14.4445 16.9889 14.4445 19.4444V53.8889C14.4445 56.3444 16.4334 58.3333 18.889 58.3333H23.889C21.4334 58.3333 19.4445 56.3444 19.4445 53.8889Z",
  fill: "#D5DBE1"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M41.1711 66.6667C40.7333 66.6667 40.3067 66.4934 39.9933 66.1778C39.6089 65.7934 39.4356 65.2445 39.5311 64.7111L40.7089 58.0333C40.7689 57.6956 40.9311 57.3845 41.1711 57.1445L57.6711 40.6445C58.3733 39.9422 59.1178 39.5022 59.8845 39.3445C60.9445 39.1178 61.9711 39.4445 62.7778 40.2511L65.5267 43C67.0422 44.5178 67.0422 46.9822 65.5267 48.5L49.0289 65C48.7867 65.24 48.4756 65.4045 48.14 65.4622L41.4622 66.64C41.3644 66.6578 41.2689 66.6667 41.1711 66.6667ZM43.9 59.1289L43.2267 62.9445L47.0422 62.2711L63.1689 46.1422C63.3845 45.9245 63.3845 45.5733 63.1689 45.3556L60.44 42.6267C60.4178 42.6689 60.2511 42.7733 60.0267 42.9978L43.9 59.1289Z",
  fill: "#75768A"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M35.5776 60H19.4443C16.0732 60 13.3332 57.26 13.3332 53.8889V19.4445C13.3332 16.0734 16.0732 13.3334 19.4443 13.3334H44.9999C48.371 13.3334 51.111 16.0734 51.111 19.4445V41.8H47.7777V19.4445C47.7777 17.9134 46.531 16.6667 44.9999 16.6667H19.4443C17.9132 16.6667 16.6665 17.9134 16.6665 19.4445V53.8889C16.6665 55.42 17.9132 56.6667 19.4443 56.6667H35.5776V60Z",
  fill: "#75768A"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M21.6668 31.1111H42.7779V34.4444H21.6668V31.1111Z",
  fill: "#75768A"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M21.6668 40H33.889V43.3333H21.6668V40Z",
  fill: "#75768A"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M21.6668 22.2222H31.6668V25.5555H21.6668V22.2222Z",
  fill: "#75768A"
});

function SvgRecentActivity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentActivity);
export default __webpack_public_path__ + "static/media/recent-activity.c71603cc.svg";
export { ForwardRef as ReactComponent };